import { Link } from 'react-router-dom'
import { H4, H5, Image, LI } from '../../../../AbstractElements'
import { registerHorizontalData } from '../../../../Data/OtherPage/OtherPage'
import { dynamicImage } from '../../../../Service'
import { PropsType } from '../../../../Type/OtherPages/OtherPages'
import CommonLogo from '../Common/CommonLogo'

const SideBarList = ({ level }: PropsType) => {
  return (
    <ul className="custom-scrollbar anchor">
      <li><CommonLogo /></li>
      {registerHorizontalData.map((data, index) => (
        <LI key={index}>
          <Link to={`#form-${index}`} className={`${level === index + 1? "selected": level > index + 1? "done": "disabled"}`} >
            <H4>{index + 1}</H4>
            <H5>
              {data.tittle}
              {data.tittle === "Done" ? (<i className="fa fa-thumbs-o-up" />) : (" ")}
            </H5>
            <small>{data.detail}</small>
          </Link>
        </LI>
      ))}
      <li>
        <Image src={dynamicImage("login/icon.png")} alt="loginpage"/>
      </li>
    </ul>
  )
}

export default SideBarList